const BASE_STAKE = 500;

export const computeRugbyLeaderboard = (rawList, homeScore, awayScore, fixture) => {
    if (!rawList || rawList.length === 0) return [];

    const homeName = fixture?.homeTeam?.name;
    const awayName = fixture?.awayTeam?.name;

    let realWinnerName = null;
    if (homeScore > awayScore) realWinnerName = homeName;
    else if (awayScore > homeScore) realWinnerName = awayName;

    const realMargin = Math.abs(homeScore - awayScore);

    const computed = rawList.map(player => {
        const {winningTeamName, predictionMargin, maxPotentialPoints, pointsLostPerMarginUnit, odds} = player;

        const isCorrectWinner = (winningTeamName === realWinnerName);

        let currentPoints = 0;
        let diff = 0;
        let penalty = 0;

        if (realWinnerName === null && !winningTeamName) {
            currentPoints = BASE_STAKE * odds
        } else if (isCorrectWinner) {
            diff = Math.abs((predictionMargin || 0) - realMargin);
            penalty = diff * (pointsLostPerMarginUnit || 0);
            currentPoints = Math.max(0, (maxPotentialPoints || 0) - penalty);
        }

        // Total = points prono (live) + bonus quiz figé (add-on), comme le back
        const quizBonus = player.quizBonus || 0;
        return {
            ...player,
            pronoPoints: currentPoints,
            quizBonus,
            points: currentPoints + quizBonus,
            stats: {
                isCorrectWinner,
                realMargin,
                marginDiff: diff,
                totalPenalty: penalty
            }
        };
    });

    computed.sort((a, b) => {
        if (b.points !== a.points) return b.points - a.points;

        if (a.stats.isCorrectWinner !== b.stats.isCorrectWinner) {
            return a.stats.isCorrectWinner ? -1 : 1;
        }

        if (a.stats.isCorrectWinner && b.stats.isCorrectWinner) {
            if (a.stats.marginDiff !== b.stats.marginDiff) {
                return a.stats.marginDiff - b.stats.marginDiff;
            }
        }

        if (a.betAt !== b.betAt) return new Date(a.betAt) - new Date(b.betAt);

        return (a.pseudo || "").localeCompare(b.pseudo || "");
    });

    return computed.map((p, index) => ({
        ...p,
        rank: index + 1,
        style: p.isMe ? 'bg-green-50 border-action-green shadow-sm z-10 scale-[1.01]' : 'bg-slate-50'
    }));
};